<template>
  <div>
    <!-- Loading overlay -->
    <div v-if="loadDetail" class="tomat-loading-overlay">
      <div class="tomat-dots">
        <div class="tomat-dot"></div>
        <div class="tomat-dot"></div>
        <div class="tomat-dot"></div>
      </div>
      <p class="tomat-loading-text">Loading...</p>
    </div>

    <div v-if="openModal" class="modal-overlay" @click.self="closeModal">
      <div class="d-flex" :class="hasPartMaster ? 'dual-modal-wrapper' : 'single-modal-wrapper'">

        <!-- Smartcat Overview (kiri, tampil hanya jika part_master ada data) -->
        <div v-if="hasPartMaster" class="modal-container modal-smartcat mr-3">
          <div class="card p-3">
            <div class="d-flex justify-content-between mb-5">
              <h4>Smartcat Overview</h4>
            </div>

            <tabs tabNavClasses="nav-fill flex-column flex-sm-row nav-wrapper mt-0"
              style="margin-top: -40px!important;padding-top: 0px!important;">
              <tab-pane>
                <span slot="title"><i class="fas fa-home"></i> OVERVIEW</span>
                <div v-if="!loadDetail" class="modal-body-scroll">
                  <div class="p-3 bg-primary text-white text-center mb-3 rounded">
                    <h2 class="mt-2 text-white">{{ detailSmartcat.part_master?.ShortDescription}}</h2>
                  </div>
                  <div class="d-flex mt-4 w-full mb-3">
                    <div class=" bg-success text-white py-4 text-center rounded" style="width: 25%;">
                      <span style="font-size: 11px;">PLANT</span>
                      <br>
                      <span style="font-size: 20px;">{{ detailSmartcat.part_master?.plant }}</span>
                    </div>
                    <div class=" bg-primary text-white py-4 text-center rounded ml-3" style="width: 25%;">
                      <span style="font-size: 11px;">CATALOG STATUS</span>
                      <br>
                      <span style="font-size: 20px;">{{ detailSmartcat.part_master?.CatStatus }}</span>
                    </div>
                    <div class=" bg-danger text-white py-4 text-center rounded ml-3" style="width: 25%;">
                      <span style="font-size: 11px;">CATALOG TYPE</span>
                      <br>
                      <span style="font-size: 20px;">{{ detailSmartcat.part_master?.CatType }}</span>
                    </div>
                    <div class=" bg-warning text-white py-4 text-center rounded ml-3" style="width: 25%;">
                      <span style="font-size: 11px;">MATERIAL NUMBER</span>
                      <br>
                      <span style="font-size: 20px;">{{ detailSmartcat.part_master?.materialNumber }}</span>
                    </div>
                  </div>

                  <div class="mb-2">
                    <h5>OLD MATEIRAL NUMBER</h5>
                    <el-input type="text" v-model="detailSmartcat.part_master.oldMaterialNumber" size="large" disabled></el-input>
                  </div>

                  <div class="mb-2">
                    <h5>LONG DESCRIPtiON</h5>
                    <el-input type="text" v-model="detailSmartcat.part_master.LongDescription" size="large" disabled></el-input>
                  </div>

                  <div class="table-responsive mb-2">
                    <h5>CHARACTERISTICS</h5>
                    <table class="table table-bordered">
                      <thead>
                        <tr>
                          <th scope="col">CHARACTERISTICS</th>
                          <th scope="col">VALUE</th>
                          <th scope="col">ABBREV</th>
                          <th scope="col">VIEW</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="char_value in detailSmartcat?.part_characteristics">
                          <th class="text-uppercase">{{ char_value?.Characteristic }}</th>
                          <td class="text-uppercase">{{ char_value?.Char_Value }}</td>
                          <td class="text-uppercase">{{ char_value?.Abbrev_Value }}</td>
                          <td class="text-uppercase text-center">
                            <el-checkbox v-if="char_value?.Short == 'YES'" disabled checked></el-checkbox>
                            <el-checkbox v-if="char_value?.Short != 'YES'" disabled></el-checkbox>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                </div>
                <skeleton-loading v-else />
              </tab-pane>

              <tab-pane>
                <span slot="title"><i class="fas fa-info-circle"></i> INFORMATION</span>
                <div class="modal-body-scroll" v-if="!loadDetail">

                  <div class="table-responsive mb-3">
                    <h5>REFERENCES</h5>
                    <table class="table table-bordered">
                      <thead>
                        <tr>
                          <th scope="col">CODE</th>
                          <th scope="col">SOURCE</th>
                          <th scope="col">MANUFACTURE REFERENCE</th>
                          <th scope="col">TYPE</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="manufacture_ref in detailSmartcat?.part_references">
                          <th class="text-uppercase">{{ manufacture_ref?.ManCode }}</th>
                          <td class="text-uppercase">{{ manufacture_ref?.SourceType }}</td>
                          <td class="text-uppercase">{{ manufacture_ref?.PartNumber }}</td>
                          <td class="text-uppercase">{{ manufacture_ref?.Type }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div class="mb-2">
                    <h5>ITEM NAME / INC</h5>
                    <el-input type="text" :value="`${detailSmartcat.part_master.INC} (${detailSmartcat.part_master.StandardName})`" size="large" disabled></el-input>
                  </div>

                  <div class="mb-2">
                    <h5>GROUP CLASS / NCS</h5>
                    <el-input type="text" :value="`${detailSmartcat.part_master.GroupClass} (${detailSmartcat.part_master.GroupClassDesc})`" size="large" disabled></el-input>
                  </div>

                </div>
                <skeleton-loading v-else />
              </tab-pane>

              <tab-pane>
                <span slot="title"><i class="fas fa-flag"></i> FLAGS</span>
                <div class="modal-body-scroll" v-if="!loadDetail">

                  <div class="table-responsive mb-3">
                    <h5>COLLOQUIALS</h5>
                    <table class="table table-bordered">
                      <thead>
                        <tr>
                          <th scope="col">COLLOQUIALS</th>
                        </tr>
                      </thead>
                      <tr v-for="sloc in detailSmartcat.part_colloquials">
                        <td class="text-uppercase">{{ sloc?.colloquial }}</td>
                      </tr>
                      <tbody></tbody>
                    </table>
                  </div>

                  <div class="table-responsive mb-3">
                    <h5>SLOCS</h5>
                    <table class="table table-bordered">
                      <thead>
                        <tr>
                          <th scope="col">PLANT</th>
                          <th scope="col">LOCATION</th>
                          <th scope="col">SHELF</th>
                          <th scope="col">BIN</th>
                        </tr>
                      </thead>
                      <tr v-for="sloc in detailSmartcat.part_slocs">
                        <td class="text-uppercase">{{ sloc?.Plant }}</td>
                        <td class="text-uppercase">{{ sloc?.Location }}</td>
                        <td class="text-uppercase">{{ sloc?.Shelf }}</td>
                        <td class="text-uppercase">{{ sloc?.BIN }}</td>
                      </tr>
                      <tbody></tbody>
                    </table>
                  </div>

                  <div class="mb-2">
                    <h5>ITEM TYPE</h5>
                    <el-input type="text" :value="detailSmartcat?.part_master?.Userclass" size="large" disabled></el-input>
                  </div>

                  <div class="mb-2">
                    <h5>STOCK TYPE</h5>
                    <el-input type="text" :value="detailSmartcat?.part_master?.StockType" size="large" disabled></el-input>
                  </div>

                  <div class="mb-2">
                    <h5>UNIT OF ISSUE</h5>
                    <el-input type="text" :value="detailSmartcat?.part_master?.unit_issue" size="large" disabled></el-input>
                  </div>

                  <div class="mb-2">
                    <h5>UNIT OF PURCHASE</h5>
                    <el-input type="text" :value="detailSmartcat?.part_master?.unit_purchase" size="large" disabled></el-input>
                  </div>
                  
                  <div class="mb-2">
                    <h5>CONVERSION</h5>
                    <el-input type="text" :value="detailSmartcat?.part_master?.conversion" size="large" disabled></el-input>
                  </div>
                  
                  <div class="mb-2">
                    <h5>MEMO</h5>
                    <el-input 
                      type="textarea" 
                      :value="detailSmartcat?.part_master?.memo_info" 
                      :placeholder="tt('po_text_memo')"
                      size="large"
                      resize="vertical" 
                      :autosize="true" 
                      disabled
                    >
                    </el-input>
                  </div>

                  <div class="mb-2">
                    <h5>LAST UPDATE BY</h5>
                    <el-input type="text" :value="detailSmartcat?.part_master?.LastUpdatedBy" size="large" disabled></el-input>
                  </div>

                  <div class="mb-2">
                    <h5>CREATED DATE</h5>
                    <el-input type="text" :value="detailSmartcat?.part_master?.created_date" size="large" disabled></el-input>
                  </div>

                  <div class="mb-2">
                    <h5>UPDATED DATE</h5>
                    <el-input type="text" :value="detailSmartcat?.part_master?.updated_date" size="large" disabled></el-input>
                  </div>

                </div>
                <skeleton-loading v-else />
              </tab-pane>

              <tab-pane>
                <span slot="title"><i class="fas fa-cogs"></i> EQUIPMENTS</span>
                <div class="modal-body-scroll" v-if="!loadDetail">

                  <div class="table-responsive mb-3">
                    <h5>EQUIPMENTS</h5>
                    <table class="table table-bordered">
                      <thead>
                        <tr>
                          <th scope="col">EQUIPMENT CODE</th>
                          <th scope="col">EQUIPMENT NAME</th>
                          <th scope="col">QUANTITY INSTALLED</th>
                        </tr>
                      </thead>
                      <tr v-for="equipment in detailSmartcat?.part_equipments">
                        <th class="text-uppercase">{{ equipment?.EquipmentCode }}</th>
                        <td class="text-uppercase">{{ equipment?.EquipmentName }}</td>
                        <td class="text-uppercase">{{ equipment?.QtyInstall }}</td>
                      </tr>
                      <tbody></tbody>
                    </table>
                  </div>

                </div>
                <skeleton-loading v-else />
              </tab-pane>

              <tab-pane>
                <span slot="title"><i class="fas fa-paragraph"></i> PO TEXT</span>
                <div class="modal-body-scroll" v-if="!loadDetail">

                  <div class="mb-2">
                    <h5>PO TEXT</h5>
                    <el-input 
                      type="textarea" 
                      :value="detailSmartcat.part_potext.length > 0 ? detailSmartcat.part_potext[0].POTEXT : ''" 
                      :placeholder="tt('po_text')" 
                      size="large"
                      resize="vertical" 
                      :autosize="true" 
                      disabled
                      >
                    </el-input>
                  </div>

                </div>
                <skeleton-loading v-else />
              </tab-pane>

              <tab-pane>
                <span slot="title"><i class="fas fa-copy"></i> DOCUMENTS</span>
                <div class="modal-body-scroll" v-if="!loadDetail">

                  <div class="table-responsive mb-3">
                    <h5>LINKS</h5>
                    <table class="table table-bordered">
                      <thead>
                        <tr>
                          <th scope="col">WEB LINK</th>
                        </tr>
                      </thead>
                      <tr v-for="link in detailSmartcat.web_links">
                        <th class="text-uppercase">
                          <a :href="link?.HttpLink" target="_blank" style="cursor: pointer;">
                            {{ link.HttpLink }}
                          </a>
                        </th>
                        <td class="text-uppercase">{{ attcahment?.attachment_description }}</td>
                        <td class="text-uppercase">{{ attcahment?.created_at }}</td>
                      </tr>
                      <tbody></tbody>
                    </table>
                  </div>

                  <div class="table-responsive mb-3">
                    <h5>DOCUMENTS</h5>
                    <table class="table table-bordered">
                      <thead>
                        <tr>
                          <th scope="col" style="width: 15%!important;">ID</th>
                          <th scope="col">DESCRIPTION</th>
                          <th scope="col" style="width: 10%!important;">CREATED BY</th>
                          <th scope="col" style="width: 10%!important;">DATE CREATED</th>
                        </tr>
                      </thead>
                      <tr v-for="document in detailSmartcat?.part_documents">
                        <td class="text-uppercase">{{ document?.Id }}</td>
                        <td class="text-uppercase">{{ document?.Description }}</td>
                        <td class="text-uppercase">{{ document?.UploadedBy }}</td>
                        <td class="text-uppercase">{{ document?.CreatedDate }}</td>
                      </tr>
                      <tbody></tbody>
                    </table>
                  </div>

                </div>
                <skeleton-loading v-else />
              </tab-pane>

            </tabs>
          </div>
        </div>

        <!-- Tomat Overview (kanan, selalu tampil) -->
        <div class="modal-container" :class="hasPartMaster ? 'modal-tomat' : 'modal-tomat-full'">
          <div class="card p-3">
            <div class="d-flex justify-content-between mb-5">
              <h4>Tomat Overview</h4>
              <button class="close-btn" @click="closeModal">&times;</button>
            </div>

            <tabs tabNavClasses="nav-fill flex-column flex-sm-row nav-wrapper mt-0"
              style="margin-top: -40px!important;padding-top: 0px!important;">

              <tab-pane>
                <span slot="title"><i class="fas fa-home"></i> OVERVIEW</span>
                <div class="modal-body-scroll">

                  <div class="p-3 bg-primary text-white text-center mb-3">
                    <h2 class="mt-2 text-white">{{ detailTomat.Deskripsi }}</h2>
                  </div>

                  <div class="mb-2">
                    <h5>OLD MATEIRAL NUMBER</h5>
                    <el-input type="text" v-model="detailTomat.OldMaterialNo" size="large" disabled></el-input>
                  </div>

                  <div class="mb-2">
                    <h5>MATEIRAL NUMBER</h5>
                    <el-input type="text" v-model="detailTomat.Material" size="large" disabled></el-input>
                  </div>

                  <div class="mb-2">
                    <h5>Material Type</h5>
                    <el-input type="text" v-model="detailTomat.Mat_Type" size="large" disabled></el-input>
                  </div>

                  <div class="mb-4">
                    <h5>Last Update</h5>
                    <el-input type="text" v-model="detailTomat.LastUpdate" size="large" disabled></el-input>
                  </div>

                  <div class="d-flex mb-3">
                    <div class="bg-success text-white py-4 text-center rounded" style="width: 40%;">
                      <span style="font-size: 11px;">PLANT</span>
                      <br>
                      <span style="font-size: 30px;">
                        {{ detailTomat.Plant }}
                      </span>
                    </div>
                    <div class="bg-danger text-white py-4 ml-4 text-center rounded" style="width: 54%;">
                      <span style="font-size: 11px;">UNRESTRICTED USED</span>
                      <br>
                      <span style="font-size: 30px;">
                        {{ detailTomat.Uu }} {{ detailTomat.BUn }}
                      </span>
                    </div>
                  </div>

                </div>
              </tab-pane>

              <tab-pane>
                <span slot="title"><i class="fas fa-paragraph"></i> PO TEXT</span>
                <div class="modal-body-scroll">

                  <div class="mb-2">
                    <el-input 
                      type="textarea" 
                      :value="detailTomat.POText" 
                      :placeholder="tt('po_text')" 
                      size="large"
                      resize="vertical" 
                      :autosize="true" 
                      disabled
                      >
                    </el-input>
                </div>
                </div>

              </tab-pane>

              <tab-pane>
                <span slot="title"><i class="fas fa-copy"></i> SLOC</span>
                <div class="modal-body-scroll">

                  <div class="bg-primary text-white mb-3 rounded p-3" v-for="sloc in detailTomat.slocs">
                    <span class="font-weight-bold">{{ sloc.Unrestricted }} {{ detailTomat.BUn }}</span>
                    <br>
                    <span>{{ sloc.Sloc }}</span>
                  </div>

                </div>
              </tab-pane>

            </tabs>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import Api from '@/helpers/api';
import tomatSearchService from '@/services/master/tomatSearch';

export default {
  name: "TomatModalDetail",
  props: ['showModal', 'sourceData'],
  data() {
    return {
      openModal: false,
      loadDetail: false,
      hasPartMaster: false,
      detailTomat: {
        slocs: []
      },
      detailSmartcat: {
        part_characteristics: [],
        part_colloquials: [],
        part_slocs: [],
        part_equipments: [],
        part_references: [],
        part_potext: [],
        web_links: [],
        part_documents: [],
        part_master: {}
      }
    }
  },
  methods: {
    getOverViewStock(stocks) {
      if (!stocks || stocks.length === 0) return '0'
      const stock = stocks[0]?.labst
      const unit = stocks[0]?.meins
      return `${this.formatingTonnage(stock)} ${unit}`
    },
    getShortAttachmentCode(str) {
      return str.length > 50 ? str.substring(0, 50) + "..." : str;
    },
    formatingTonnage(tonnage) {
      const tonnage_splitted = tonnage.split('.');
      if (tonnage_splitted.length == 1) return tonnage
      const last_digit = tonnage_splitted[tonnage_splitted.length - 1]
      tonnage_splitted.pop()
      const formatting_tonnage = parseInt(tonnage_splitted.join(""), 10).toLocaleString("id-ID");
      return last_digit == 0 ? formatting_tonnage : `${formatting_tonnage},${last_digit}`
    },
    getDetail() {
      this.loadDetail = true
      this.openModal = false
      this.hasPartMaster = false

      const material_number = this.sourceData?.Material
      const plant = this.sourceData?.Plant

      Api(this, tomatSearchService.detailTomatV2(material_number, plant))
        .onSuccess(response => {
          const data = response.data.data
          this.detailTomat = {
            ... this.sourceData,
            slocs: data?.tomat_sloc
          }

          if (data.part_master) {
            this.hasPartMaster = true
            this.detailSmartcat = {
              part_characteristics: data?.part_characteristics,
              part_colloquials: data?.part_colloquials,
              part_slocs: data?.part_slocs,
              part_equipments: data?.part_equipments,
              part_references: data?.part_references,
              part_potext: data?.part_potext,
              web_links: data?.web_links,
              part_documents: data?.part_documents,
              part_master: data.part_master
            }
          }

          this.loadDetail = false
          this.openModal = true
        }).onError(error => {
          this.resetDetailData()
          this.loadDetail = false
        }).call();
    },
    resetDetailData() {
      this.detailSmartcat = {
        part_characteristics: [],
        part_colloquials: [],
        part_slocs: [],
        part_equipments: [],
        part_references: [],
        part_potext: [],
        web_links: [],
        part_documents: [],
        part_master: {}
      }

      this.detailTomat = {
        slocs: []
      }
    },
    closeModal() {
      this.openModal = false
      this.$emit('close-modal')
    }
  },
  watch: {
    showModal(val) {
      if (val) this.getDetail()
    }
  },
};
</script>

<style>
body {
  overflow: auto !important;
}

.tomat-loading-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  z-index: 99999;
}

.tomat-loading-text {
  color: #fff;
  font-size: 14px;
  letter-spacing: 1px;
  margin: 0;
  opacity: 0.8;
}

.tomat-dots {
  display: flex;
  gap: 10px;
  align-items: center;
}

.tomat-dot {
  width: 14px;
  height: 14px;
  background: #fff;
  border-radius: 50%;
  animation: tomat-bounce 0.6s ease-in-out infinite;
}

.tomat-dot:nth-child(2) { animation-delay: 0.15s; }
.tomat-dot:nth-child(3) { animation-delay: 0.3s; }

@keyframes tomat-bounce {
  0%, 100% { transform: translateY(0); opacity: 0.4; }
  50%       { transform: translateY(-12px); opacity: 1; }
}

.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding-top: 40px;
  z-index: 9999;
}

.single-modal-wrapper {
  width: 80%;
  justify-content: center;
}

.dual-modal-wrapper {
  width: 95%;
  justify-content: center;
}

.modal-full {
  width: 100%;
}

.modal-smartcat {
  width: 66%;
}

.modal-tomat {
  width: 34%;
}

.modal-tomat-full {
  width: 40%;
}

.modal-container {
  background: #FFFFFF;
  border-radius: 4px;
  overflow: hidden;
  animation: modalFade 0.35s ease;
  max-height: 97vh;
  display: flex;
  flex-direction: column;
}

.modal-container .card {
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.close-btn {
  position: absolute;
  top: 15px;
  right: 20px;
  font-size: 28px;
  background: none;
  border: none;
  cursor: pointer;
  color: #000;
  opacity: 0.5;
  transition: opacity 0.2s ease;
  margin-top: -10px !important;
}

.close-btn:hover {
  opacity: 0.75;
}

.modal-body-scroll {
  overflow-y: auto;
  max-height: 95vh;
}

thead th {
  font-size: 13px !important;
  font-weight: 600;
}

tbody td,
tbody th {
  font-size: 15px !important;
}

@keyframes modalFade {
  0% {
    opacity: 0;
    transform: translateY(-20px);
  }

  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
